<div class="dialog-form" *ngIf="roleForm">
  <form [formGroup]="roleForm" (submit)="formValidations() && save()">
      <div class="form-group space-evenly">
        <div class="selectorInputBox">
          <div class="form-control">
            <label for="id">Id</label>
            <input pInputText type="text" formControlName="id" readonly name="id">
          </div>
          <div class="form-control">
            <label for="name">{{'FIRST-NAME' | translate}}</label>
            <input pInputText type="text" formControlName="name" name="name">
          </div>
          <!-- Hierarquia aguardando homologação da equipe de negócios para completa remoção
          
          <div class="form-control">
            <label for="hierarchy">{{'Hierarquia' | translate}}</label>
            <p-dropdown placeholder="Selecione..." [filter]="false" [options]="hierarchyList"
              formControlName="hierarchy" name="hierarchy">
            </p-dropdown>
          </div> -->
        </div>
        <div class="switchBox">
          <div class="switchSelectors">
            <label for="name">{{'MANAGE-PHOTOS' | translate}}</label>
            <p-inputSwitch (onChange)="changePhotos($event)" id="photos" name="photos" formControlName="photos"
            ></p-inputSwitch>
          </div>
          <div class="switchSelectors" pTooltip="Serão liberados para esse perfil de usuário as seguintes funcionalidades: Cancelar pagamento, cancelar boleto, cancelar fatura e aplicar descontos">
            <label for="name" >{{'ADMINISTRATOR' | translate}}</label>
            <p-inputSwitch (onChange)="changeAdministrator($event)" id="administrator" name="administrator" formControlName="administrator"></p-inputSwitch>
          </div>
          <div class="switchSelectors" pTooltip="Esse se torna um perfil Operador Responsável que gerencia apenas as embarcações designadas.">
            <label for="name" >{{'RESP-OPERATOR' | translate}}</label>
            <p-inputSwitch (onChange)="changeResponsible($event)" id="responsible" name="responsible" formControlName="responsible"></p-inputSwitch>
          </div>

          <div class="switchSelectors" pTooltip="Esse se torna um perfil capaz de alterar as datas de Vencimento e Competência de uma Fatura">
            <label for="name" >{{'CHANGE-INVOICE-DATES' | translate}}</label>
            <p-inputSwitch (onChange)="changeInvoiceDatesPermission($event)" id="changeInvoiceDates" name="changeInvoiceDates" formControlName="changeInvoiceDates"></p-inputSwitch>
          </div>
            <div *ngIf="isMovement" class="switchSelectors" pTooltip="Esse torna um perfil capaz de alterar o status da movimentação">
                <label for="name" >{{'IS-DOC-MASTER' | translate}}</label>
                <p-inputSwitch (onChange)="changeDocMaster($event)" id="docMaster" name="docMaster" formControlName="docMaster"></p-inputSwitch>
            </div>  
        </div>
      </div>
      <br>
      <!-- EAS-327: permissões de ação do perfil (saíram do cadeado por usuário). Vazia sem o EAS-327 no backend. -->
      <div class="role-capabilities" *ngIf="capabilityCategories.length > 0">
        <div class="capabilities-title">
          <span><i class="pi pi-sliders-h"></i> Permissões de ação</span>
          <small *ngIf="capabilitiesReadOnly">
            Perfil padrão do sistema — recorte fixo, não editável.
          </small>
          <small *ngIf="!capabilitiesReadOnly">
            O que este perfil pode executar. Sem nenhuma marcação, o perfil segue como está hoje.
          </small>
        </div>
        <div class="capabilities">
          <div class="category" *ngFor="let group of capabilityCategories">
            <div class="category-header">
              <span class="category-name">
                <i class="pi" [ngClass]="capabilityCategoryIcon(group.name)"></i>
                {{ capabilityCategoryLabel(group.name) }}
                <span class="category-count">{{ selectedCapabilityCount(group) }}/{{ group.caps.length }}</span>
              </span>
              <span class="category-actions" *ngIf="!capabilitiesReadOnly">
                <button type="button" class="link-btn" pTooltip="Marcar tudo" tooltipPosition="top"
                        (click)="toggleCapabilityCategory(group, true)">
                  <i class="pi pi-check-circle"></i>
                </button>
                <button type="button" class="link-btn" pTooltip="Limpar" tooltipPosition="top"
                        (click)="toggleCapabilityCategory(group, false)">
                  <i class="pi pi-circle"></i>
                </button>
              </span>
            </div>
            <div class="capability-grid">
              <label class="capability" *ngFor="let cap of group.caps"
                     [class.checked]="selectedCapabilities[cap.code]">
                <p-checkbox [binary]="true" [(ngModel)]="selectedCapabilities[cap.code]"
                            [ngModelOptions]="{ standalone: true }" [disabled]="capabilitiesReadOnly"
                            (onChange)="markCapabilitiesDirty()" [name]="cap.code"></p-checkbox>
                <span class="capability-label">{{ cap.description }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="form-group space-evenly">
          <div class="form-control">
              <label for="selectedItensWeb">Aplicação Easy Web</label>
              <p-listbox [options]="menuItensListWeb" filter="true" multiple="multiple" checkbox="checkbox"
                  metaKeySelection="false" formControlName="selectedItensWeb" name="selectedItensWeb"
                  (onChange)="updateMenuItens()" [listStyle]="{'max-height':'250px'}">
              </p-listbox>
          </div>
          <div class="form-control" *ngIf="empetyList(menuItensListGestor)">
              <label for="selectedItensGestor">Aplicação App Operador</label>
              <p-listbox [options]="menuItensListGestor" filter="true" multiple="multiple" checkbox="checkbox"
                  formControlName="selectedItensGestor" name="selectedItensGestor" (onChange)="updateMenuItens()"
                  [listStyle]="{'max-height': '250px'}">
              </p-listbox>
          </div>
      </div>
      <div class="form-group align-center">
          <div class="form-control">
              {{'REQUIRED-FIELDS' | translate}}
          </div>
          <div class="buttons">
              <button class="easymarine danger" type="button" (click)="dialogRef.close()">{{ 'CANCEL' | translate
                  }}</button>
              <button class="easymarine primary" type="submit">{{ 'SAVE' | translate }}</button>
          </div>
      </div>
  </form>
</div>
